import css from 'styled-jsx/css';
import { colors } from '../../../../themes/index';

export default css`
  h1,
  .title {
    color: ${colors.grayDeep};
    font-size: 1.0625em; /* 17/16 */
    font-weight: normal;
    line-height: 1.3;
    margin-bottom: 5px;
  }

  .title h1 {
    display: inline;
    font-size: 0.93em;
  }
`;



// WEBPACK FOOTER //
// ./app/components/shared/Titles/SearchTitle/styles.js